import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=b307d612&scoped=true&lang=html&"
import script from "./ProfileInfo.vue?vue&type=script&lang=js&"
export * from "./ProfileInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=b307d612&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b307d612",
  null
  
)

export default component.exports